import deliveryPointList from "./delivery-point-list/DeliveryPointList.vue";
import i18n from "../../i18n/index";
import deliveryPointService from "../../services/delivery-point/DeliveryPointService";
import locationService from '../../services/location/LocationService.js'

export default {
  components: {
    deliveryPointList
  },
  data: () => ({
    hideList: false,
    loading: false,
    deliveryPoints: [],
    deliveryPoint: {
      id: null,
      name: '',
      roadType: '',
      addressNumberOne: '',
      addressNumberTwo: '',
      addressNumberThree: '',
      addressObservation: '',
      active: true
    },
    location: {
      city: '',
      state: ''
    },
    rules: [value => !!value || i18n.t('field-required')],
    loadingDelete: false,
    loadingSaveButton: false,
    showAdd: true,
    showIcon: false,
    showUpdate: false,
    showDelete: false,
    states: [],
    cities: [],
    roadTypes: [
      "Anillo",
      "Autopista",
      "Avenida",
      "Avenida Calle",
      "Avenida Carrera",
      "Calle",
      "Carrera",
      "Circular",
      "Diagonal",
      "Transversal",
      "Zona"
    ],
  }),
  async mounted() {
    await this.getStates()
  },
  methods: {
    async handle(item) {
      this.hideList = true;
      this.loadingSaveButton = false;
      this.deliveryPoint.id = item.id;
      this.deliveryPoint.name = item.name;
      this.deliveryPoint.active = item.active;
      this.deliveryPoint.roadType = item.roadType;
      this.deliveryPoint.addressNumberOne = item.addressNumberOne;
      this.deliveryPoint.addressNumberTwo = item.addressNumberTwo;
      this.deliveryPoint.addressNumberThree = item.addressNumberThree;
      this.deliveryPoint.addressObservation = item.addressObservation;
      this.location.state = item.city.idState.id;
      await this.getCities()
      this.location.city = item.city.id;
      this.showAdd = false;
      this.showIcon = false;
      this.showUpdate = true;
      this.showDelete = true;
    },
    close() {
      this.hideList = false;
      this.loadingSaveButton = false;
      this.deliveryPoint = {
        id: null,
        name: '',
        roadType: '',
        addressNumberOne: '',
        addressNumberTwo: '',
        addressNumberThree: '',
        addressObservation: '',
        active: true
      };
      this.location = {
        city: '',
        state: ''
      }
      this.cities = []
      this.$refs.deliveryPointList.getDeliveryPoints();
      this.showAdd = true;
      this.showUpdate = false;
      this.showIcon = false;
      this.showDelete = false;
    },
    async save() {
      if (this.deliveryPoint.name === '' || this.deliveryPoint.name === undefined || this.deliveryPoint.name === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'El campo nombre es obligatorio'
        });
        return
      }
      if (this.location.state === '' || this.location.state === undefined || this.location.state === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'El campo departamento es obligatorio'
        });
        return
      }
      if (this.location.city === '' || this.location.city === undefined || this.location.city === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'El campo ciudad es obligatorio'
        });
        return
      }
      if (this.deliveryPoint.roadType === '' || this.deliveryPoint.roadType === undefined || this.deliveryPoint.roadType === null ||
        this.deliveryPoint.addressNumberOne === '' || this.deliveryPoint.addressNumberOne === undefined || this.deliveryPoint.addressNumberOne === null ||
        this.deliveryPoint.addressNumberTwo === '' || this.deliveryPoint.addressNumberTwo === undefined || this.deliveryPoint.addressNumberTwo === null ||
        this.deliveryPoint.addressNumberThree === '' || this.deliveryPoint.addressNumberThree === undefined || this.deliveryPoint.addressNumberThree === null
      ) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Todos los campos de la dirección son obligatorios'
        });
        return
      }
      if (this.$refs.form.validate()) {
        try {
          let response = await deliveryPointService.create(this.deliveryPoint, this.location)
          this.$notify({
            group: "app",
            type: "success",
            text: 'Punto de entrega creado exitosamente'
          });
          this.loadingSaveButton = false;
          this.close();
        } catch (error) {
          this.$notify({
            group: "app",
            type: "error",
            text: 'Error al crear el punto de entrega'
          });
          this.loadingSaveButton = false;
        }
      }
    },
    async deleteDeliveryPoint() {
      let data = { id: this.deliveryPoint.id };
      this.loadingDelete = true;
      try {
        let response1 = await deliveryPointService.validateDelete(data)
        if (response1.data === 'OK') {
          const accept = confirm("¿Está seguro de que desea eliminar el punto de entrega?");
          if (accept) {
            let response2 = await deliveryPointService.delete(data)
            this.$notify({
              group: "app",
              type: "success",
              text: 'Punto de entrega eliminado exitosamente'
            });
            this.loadingDelete = false;
            this.close();
          } else {
            this.loadingDelete = false;
          }
        } else {
          this.$notify({
            group: "app",
            type: "error",
            text: 'No se puede eliminar el punto de entrega dado que tiene citas asociadas. Inactive el punto de entrega'
          });
          this.loadingDelete = false;
        }
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error al eliminar el punto de entrega'
        });
        this.loadingSaveButton = false;
      }
    },
    update() {
      if (this.deliveryPoint.name === '' || this.deliveryPoint.name === undefined || this.deliveryPoint.name === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'El campo nombre es obligatorio'
        });
        return
      }
      if (this.location.state === '' || this.location.state === undefined || this.location.state === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'El campo departamento es obligatorio'
        });
        return
      }
      if (this.location.city === '' || this.location.city === undefined || this.location.city === null) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'El campo ciudad es obligatorio'
        });
        return
      }
      if (this.deliveryPoint.roadType === '' || this.deliveryPoint.roadType === undefined || this.deliveryPoint.roadType === null ||
        this.deliveryPoint.addressNumberOne === '' || this.deliveryPoint.addressNumberOne === undefined || this.deliveryPoint.addressNumberOne === null ||
        this.deliveryPoint.addressNumberTwo === '' || this.deliveryPoint.addressNumberTwo === undefined || this.deliveryPoint.addressNumberTwo === null ||
        this.deliveryPoint.addressNumberThree === '' || this.deliveryPoint.addressNumberThree === undefined || this.deliveryPoint.addressNumberThree === null
      ) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Todos los campos de la dirección son obligatorios'
        });
        return
      }
      let deliveryPointId = this.deliveryPoint.id;
      this.loadingSaveButton = true;
      this.showIcon = true;

      try {
        let response = deliveryPointService.update(deliveryPointId, this.deliveryPoint, this.location)
        this.loadingSaveButton = false;
        this.$notify({
          group: "app",
          type: "success",
          text: "Punto de entrega actualizado exitosamente"
        });
        this.$refs.deliveryPointList.getDeliveryPoints();
        this.close();
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error al actualizar el punto de entrega'
        });
        this.loadingSaveButton = false;
      }
    },
    async getStates() {
      try {
        let response = await locationService.getStatesByCountry()
        this.states = response.data
        this.location.state = ''
        this.location.city = ''
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    async getCities() {
      try {
        let response = await locationService.getCitiesByState(this.location.state)
        this.cities = response.data
        this.location.city = ''
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: 'Error'
        })
      }
    },
    noSpecialCharacters(e) {
      const key = e.key;
      if (!/[a-zA-Z0-9 -]/.test(key)) {
        return e.preventDefault();
      }
    }
  }
};
